import { useEffect, useState } from 'react';
import { io } from 'socket.io-client';

export const useWebSockets = query => {
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    const createSocket = () => {
      const newSocket = io(`${window.APP_CONFIG.env.API_HOST}/websocket`, {
        path: '/socket.io',
        transports: ['websocket'],
      });

      return newSocket;
    };

    const newSocket = createSocket();

    if (socket) {
      socket.disconnect();
    }

    setSocket(newSocket);

    return () => {
      if (newSocket) {
        newSocket.disconnect();
      }
    };
  }, []);

  return socket;
};
